<template>
  <v-container
    fluid>
    <v-row>
      <v-col
        cols="12"
        :md="selectItem ? '8' : '12'"
        class="table-detail">
        <v-data-table
          :headers="header"
          :items="items"
          :options.sync="options"
          :items-per-page="options.itemsPerPage"
          :server-items-length="total"
          :loading="loading"
          :search="inputSearch"
          :footer-props="{'items-per-page-options': [15, 25, 50, 100]}"
          class="w-full"
          @update:options="getData()"
        >
          <template v-slot:top>
            <v-toolbar flat>
              <v-toolbar-title>
                <span class="capitalize"> Tiktok API Token Logs </span>
              </v-toolbar-title>
              <v-divider
                class="mx-4"
                inset
                vertical />
              <v-spacer />
              <v-btn
                icon
                @click="getData()">
                <v-icon>mdi-refresh</v-icon>
              </v-btn>
            </v-toolbar>
          </template>

          <template #[`item.createdAt`]="{ item }">
            {{ item.createdAt | dateTimeFormat() }}
          </template>
          <template #[`item.accessTokenExpireIn`]="{ item }">
            {{ item.accessTokenExpireIn | dateTimeFormat() }}
          </template>
          <template #[`item.status`]="{ item }">
            <div
              class="text-bold status"
              :style="getMethodStyle(item.status)">
              {{ item.status.toUpperCase() }}
            </div>
          </template>
          <template #[`item.description`]="{ item }">
            <span
              class="text-bold"
              :style="getStatusStyle(item.httpStatus)">{{ item.httpStatus }}</span> {{ item.description }}
          </template>
          <template #[`item.newToken`]="{ item }">
            <v-btn
              small
              outlined
              @click="refreshToken(item.id)">
              <v-icon size="16px">
                mdi-refresh
              </v-icon>
              New Token
            </v-btn>
          </template>
          <template #[`item.option`]="{ item }">
            <v-btn
              v-if="!selectItem || selectItem.id !== item.id"
              link
              icon
              x-small
              @click="showItemDetail(item)">
              <v-icon>
                mdi-magnify
              </v-icon>
            </v-btn>
          </template>
        </v-data-table>
      </v-col>
      <v-col
        v-if="selectItem"
        cols="12"
        md="4"
        class="pa-0">
        <div class="log-detail">
          <p class="mb-1 text-bold">
            Status
            <span
              class=" status"
              :style="getMethodStyle(selectItem.status)">
              {{ selectItem.status.toUpperCase() }}
            </span>
          </p>
          <p class="mb-1">
            <b>Brand </b>{{ selectItem.brand }}
          </p>
          <p class="mb-1">
            <b>Date </b>{{ selectItem.createdAt | dateTimeFormat() }}
          </p>
          <p class="mb-1">
            <b>Open ID </b>{{ selectItem.openId }}
          </p>
          <p class="mb-1">
            <b>Refresh Token Expire In </b>{{ selectItem.refreshTokenExpireIn | dateTimeFormat() }}
          </p>
          <p class="mb-1">
            <b>Seller Base Region </b>{{ selectItem.sellerBaseRegion }}
          </p>
          <p class="mb-1">
            <b>Seller Name </b>{{ selectItem.sellerName }}
          </p>

          <p class="my-4">
            Granted Scopes
          </p>
          <div style="border: 1px solid #000;">
            <json-viewer
              :value="selectItem.grantedScopes"
              :expand-depth="1"
              copyable />
          </div>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import TiktokProvider from '@/resources/TiktokProvider'

const TiktokService = new TiktokProvider()

export default {
  components: {
    // BcLogDetail
  },
  data () {
    return {
      inputSearch: '',
      loading: false,
      selectItem: null,
      showDetail: false,
      total: 0,
      options: {
        page: 1,
        itemsPerPage: 25,
        sortBy: ['createdAt'],
        sortDesc: [true]
      },
      header: [
        {
          text: 'Brand',
          value: 'brand'
        },
        {
          text: 'Date',
          value: 'createdAt'
        },
        {
          text: 'Status',
          value: 'status'
        },
        {
          text: 'Expire In',
          value: 'accessTokenExpireIn'
        },
        {
          text: 'Options',
          value: 'option',
          align: 'center'
        },
        {
          text: 'New Token',
          value: 'newToken',
          align: 'center'
        }
      ],
      items: []
    }
  },
  created () {
    this.getData(true)
  },
  methods: {
    showItemDetail (item) {
      this.selectItem = item
      this.showDetail = true
    },
    scrollTo (tag) {
      const el = this.$refs[tag]
      if (el) {
        el.scrollIntoView({ behavior: 'smooth' })
      }
    },
    getMethodStyle (status) {
      switch (status) {
        case 'active':
          return 'color: #3b9c28; background-color: #eef6e9;'
        case 'expired':
          return 'color: #e93e4c; background-color: #ffecec;'
        case 'inactive':
          return 'color: #d4d4d4; background-color: #f8f8f8;'
        default:
          return 'color: #18171d; background-color: #f8f8f8;'
      }
    },
    async getData (clear = false) {
      if (clear) {
        this.options.page = 1
      }
      try {
        this.loading = true
        const { data: { results, total } } = await TiktokService.getTokenLogs(
          {
            page: this.options.page,
            limit: this.options.itemsPerPage,
            sortBy: this.options.sortBy[0],
            sortOrder: this.options.sortDesc[0] ? 'desc' : 'asc'
          }
        )

        this.items = results.map((re) => {
          let { status } = re
          const now = new Date()
          if (now - new Date(re.accessTokenExpireIn) > 0) {
            status = 'expired'
          }

          return {
            ...re,
            status
          }
        })
        this.total = total
        if (clear && results.length !== 0) {
          this.selectItem = this.items[0]
        }
      } catch (error) {
        this.$store.dispatch('Components/setSnackbar', {
          value: true,
          message: `Error ${error.message}`,
          type: 'error'
        })
      } finally {
        this.loading = false
      }
    },
    async refreshToken (id) {
      try {
        const data = await TiktokService.refreshToken(id)
        if (data) {
          this.$store.dispatch('Components/setSnackbar', {
          value: true,
          message: 'Success',
          type: 'success'
        })
        }
      } catch (error) {
        this.$store.dispatch('Components/setSnackbar', {
          value: true,
          message: `Error ${error.message}`,
          type: 'error'
        })
      } finally {
        this.loading = false
        await this.getData(true)
      }
    }
  }
}
</script>
<style scoped>
.table-detail {
  height: calc(100vh - 80px);
  overflow-y: auto;
  background-color: #fff;
}
.log-detail {
  width: 100%;
  margin-left: 10px;
  padding: 10px;
  height: 100%;
  overflow-y: auto;
  height: calc(100vh - 80px);
  background-color: #fff;
}
.status {
  padding: 4px;
  border-radius: 6px;
  width: 80px;
  text-align: center;
}
</style>
